import { render } from "./Bill.vue?vue&type=template&id=53c176d6"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Bill.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53c176d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53c176d6', __exports__)) {
    api.reload('53c176d6', __exports__)
  }
  
  module.hot.accept("./Bill.vue?vue&type=template&id=53c176d6", () => {
    api.rerender('53c176d6', render)
  })

}


export default __exports__